export default state => state.savedItems.boards.shareId;
